import * as React from "react";
import { Form, Option, useFormApi } from "informed";
import { Dropdown } from "../../../../forms/informedv2/Dropdown";

interface ToggleSuppressSessionProps {
    originalSuppressState: string;
    correctedSuppressState: string;
    onNext: (correctedSuppressState: string) => void;
    onChange: (correctedSuppressState: string) => void;
}

interface ToggleSuppressSessionForm {
    correctedSuppressedState: string;
}

const options = [{
    Id: "true",
    Name: "Suppressed"
}, {
        Id: "false",
        Name: "Not Suppressed"
    }];

export const ToggleSuppressSession = ({ originalSuppressState, correctedSuppressState, onNext, onChange }: ToggleSuppressSessionProps): JSX.Element => {
    const formApi = useFormApi<ToggleSuppressSessionForm>();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getState();

        if (state.invalid)
            return;

        onNext(state.values.correctedSuppressedState);
    }

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Toggle Cough Session Suppress State
                    </p>
                        <div className="form-group">
                            <label>Current Cough Session Suppress State</label>&nbsp;
                        {
                                <Dropdown
                                    disabled={true}
                                    id={`select-issuppressed-prevalue`}
                                    field="originalSuppressedState"
                                    className="form-control"
                                >
                                    {options.map(s => (
                                        <Option key={`IsSuppressedPre${s.Id}`} value={s.Id}>
                                            {s.Name}
                                        </Option>
                                    ))}
                                </Dropdown>
                            }
                        </div>
                        <div className="form-group">
                            <label>Change Cough Session Suppress State</label>&nbsp;
                            {
                                <Dropdown
                                    disabled={false}
                                    id={`select-issuppressed-correctedvalue`}
                                    onChange={e => { onChange(e.target.value) }}
                                    field="correctedSuppressedState"
                                    className="form-control"
                                >
                                    {options.map(s => (
                                        <Option key={`IsSuppressedPre${s.Id}`} value={s.Id}>
                                            {s.Name}
                                        </Option>
                                    ))}
                                </Dropdown>
                            }
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button disabled={!correctedSuppressState || correctedSuppressState == originalSuppressState} className="btn btn-primary" type="submit" onClick={() => onSubmit()}>Next</button>
            </div>
        </>);
};
